import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-state--Draft",
  "use": "icon-state--Draft-usage",
  "viewBox": "0 0 67.438 16.745",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 67.438 16.745\" id=\"icon-state--Draft\">\n<g id=\"icon-state--Draft_state--draft\">\n\t<circle style=\"fill:#F7CF80;\" cx=\"59.064\" cy=\"8.371\" r=\"8.373\" />\n\t<circle style=\"fill:#F7CF80;\" cx=\"33.72\" cy=\"8.371\" r=\"8.373\" />\n\t<circle style=\"fill:#F7CF80;\" cx=\"8.375\" cy=\"8.371\" r=\"8.373\" />\n</g>\n<g id=\"icon-state--Draft_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol